/**
 * The no-invoice-line copy: ONE source for the NotesFeed band, the
 * Pre-billing summary cell and the CM-home attention card, so the
 * renderers can never drift ("wording is law").
 *
 * Two states, each telling the person what to do (LP-27). A note kicked
 * back at hours above zero (the pipeline held its line back because the
 * note does not say enough to support the billed time) keeps the hours
 * framing. Every other note with no line
 * reads one neutral line with no hours framing: a zero-hour note, a note
 * whose model gave no line, and a line that was only "No charge".
 *
 * MARKER_ONLY_HINT sits under a summary editor whose text is only a
 * no-charge marker: Save stays off, and this says why. None of this copy
 * names a figure; care managers read all of it.
 */
export function insufficientContentMessage(hours: number, kickedBack: boolean): string {
  return hours > 0 && kickedBack
    ? `To bill ${hours} hours, this note needs a little more about what you did and for whom. Add a line or two, or write the invoice summary yourself on the note.`
    : "There's no invoice summary for this note yet. Add a line about what you did, or write the summary yourself on the note.";
}

export const MARKER_ONLY_HINT = '"No charge" needs a few words about what you did for the client.';

/** Save summary pressed with the box empty: what is missing. */
export const SUMMARY_MISSING = 'The invoice summary is empty. Write what was done, then save.';
